var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomAverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Custom_-_Average_svg__clip0)",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.283 8.534h3.462m4.149 0h3.462m-13.076 0c1.217-3.112 4.426-7.467 7.53 0 3.103 7.467 6.11 3.111 7.225 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Custom_-_Average_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgCustomAverage;